// FontLoader component to handle font loading gracefully
'use client';

import { useEffect, useState } from 'react';

const FontLoader = () => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    // Check if fonts are loaded
    if (typeof document !== 'undefined') {
      // Use Font Loading API if available
      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          setFontLoaded(true);
        }).catch(() => {
          // Fallback if font loading fails
          setFontLoaded(true);
        });
      } else {
        // Fallback for browsers that don't support Font Loading API
        setFontLoaded(true);
      }
    }
  }, []);

  // We don't render anything, just handle font loading
  return null;
};

export default FontLoader;